import EFPicture from 'elem/compCommon/EFPicture';
import PortableDesign from '@elem/SVGIcon/VanlifeRoadtrips/PortableDesign';
import PlugAndPlay from '@elem/SVGIcon/PowerBackup/PlugAndPlay';
import Battery from '@elem/SVGIcon/VanlifeRoadtrips/Battery';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D() {
    const { useLang } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const icons: any = [
        {
            icon: <PortableDesign />,
            text: t('secD_tag1'),
        },
        {
            icon: <PlugAndPlay className="color" />,
            text: t('secD_tag2'),
        },
        {
            icon: <Battery />,
            text: t('secD_tag3'),
        },
    ];
    return (
        <div id="outdoor-recreation-D" className={`outdoor-recreation-D ${css['outdoor-recreation-D']}`}>
            <div className="img-box">
                <EFPicture
                    src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716539782623/d_au_1366.png"
                    srcMobile="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716540095731/d_au_375.png"
                    alt={t('secD_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secD_title')}</p>
                    <p className="desc">{t('secD_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
